import type { ArchbaseRemoteApiClient } from '@archbase/data';
import { injectable, inject } from 'inversify';
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core';
import type { ApiClientDto, ApiClientCreateResponse } from '@domain/apiClient/ApiClientDto';

const BASE = '/api/v1/admin/clients';

@injectable()
export class RouteXApiClientService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  async findAll(page = 0, size = 20): Promise<{ content: ApiClientDto[]; totalElements: number }> {
    return this.client.get(`${BASE}?page=${page}&size=${size}`);
  }

  async findById(id: string): Promise<ApiClientDto> {
    return this.client.get(`${BASE}/${id}`);
  }

  async create(dto: Partial<ApiClientDto>): Promise<ApiClientCreateResponse> {
    return this.client.post(BASE, dto);
  }

  async update(id: string, dto: Partial<ApiClientDto>): Promise<ApiClientDto> {
    return this.client.put(`${BASE}/${id}`, dto);
  }

  async regenerateKey(id: string): Promise<{ id: string; apiKey: string; message: string }> {
    return this.client.post(`${BASE}/${id}/regenerate-key`, {});
  }

  async activate(id: string): Promise<void> {
    return this.client.patch(`${BASE}/${id}/activate`, {});
  }

  async deactivate(id: string): Promise<void> {
    return this.client.patch(`${BASE}/${id}/deactivate`, {});
  }
}
